"use strict";

var Ajaxinate = function (config) {
  var settings = config || {},
    defaultSettings = {
      pagination: ".AjaxinatePagination",
      method: "scroll",
      container: ".AjaxinateLoop",
      offset: 0,
      loadingText: "",
      beforeLoad: function() {},  // New: Default beforeLoad callback
      afterLoad: function() {},   // New: Default afterLoad callback
    };
  this.settings = Object.assign(defaultSettings, settings);
  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.destroy = this.destroy.bind(this);
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);
  this.initialize();
};

Ajaxinate.prototype.initialize = function () {
  if (this.containerElement) {
    var initializers = {
      click: this.addClickListener,
      scroll: this.addScrollListeners,
    };
    initializers[this.settings.method]();
  }
};

Ajaxinate.prototype.addScrollListeners = function () {
  if (this.paginationElement) {
    document.addEventListener("scroll", this.checkIfPaginationInView);
    window.addEventListener("resize", this.checkIfPaginationInView);
    window.addEventListener("orientationchange", this.checkIfPaginationInView);
  }
};

Ajaxinate.prototype.addClickListener = function () {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    this.clickActive = true;
    if (this.nextPageLinkElement !== null) {
      this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
    }
  }
};

Ajaxinate.prototype.stopMultipleClicks = function (event) {
  event.preventDefault();
  if (this.clickActive) {
    var spinnerElement = document.createElement("div");
    spinnerElement.classList.add("spinner");
    this.nextPageLinkElement.innerHTML = "";
    this.nextPageLinkElement.appendChild(spinnerElement);
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function () {
  var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset,
      bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    this.removeScrollListener();
    if (this.nextPageLinkElement) {
      var spinnerElement = document.createElement("div");
      spinnerElement.classList.add("spinner");
      this.nextPageLinkElement.innerHTML = "";
      this.nextPageLinkElement.appendChild(spinnerElement);
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

// Ajaxinate.prototype.loadMore = function () {
//   // Call the beforeLoad callback before making the AJAX request
//   this.settings.beforeLoad();

//   this.request = new XMLHttpRequest();
//   this.request.onreadystatechange = function () {
//     if (this.request.readyState === 4 && this.request.status === 200) {
//       var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0],
//           newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];

//       this.containerElement.insertAdjacentHTML("beforeend", newContainer.innerHTML);
//       this.paginationElement.innerHTML = newPagination.innerHTML;

//       // Call the afterLoad callback after new content is inserted
//       this.settings.afterLoad();

//       this.initialize();  // Re-initialize event listeners for the new pagination element
//     }
//   }.bind(this);
//   this.request.open("GET", this.nextPageUrl);
//   this.request.responseType = "document";
//   this.request.send();
// };


Ajaxinate.prototype.loadMore = function () {
  this.settings.beforeLoad();

  this.request = new XMLHttpRequest();
  this.request.onreadystatechange = function () {
    if (this.request.readyState === 4 && this.request.status === 200) {
      var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0],
          newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];

      if (newContainer) {
        this.containerElement.insertAdjacentHTML("beforeend", newContainer.innerHTML);
      }
      if (newPagination) {
        this.paginationElement.innerHTML = newPagination.innerHTML;
      } else {
        // No more pagination, hide the pagination element
        if (this.paginationElement) this.paginationElement.style.display = "none";
      }

      this.settings.afterLoad();
      this.initialize(); // Re-initialize event listeners for the new pagination element
    }
  }.bind(this);
  this.request.open("GET", this.nextPageUrl);
  this.request.responseType = "document";
  this.request.send();
};

Ajaxinate.prototype.removeClickListener = function () {
  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.removeEventListener("click", this.stopMultipleClicks);
  }
};

Ajaxinate.prototype.removeScrollListener = function () {
  document.removeEventListener("scroll", this.checkIfPaginationInView);
  window.removeEventListener("resize", this.checkIfPaginationInView);
  window.removeEventListener("orientationchange", this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function () {
  var destroyers = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener,
  };
  destroyers[this.settings.method]();
  return this;
};
